import type { Templates } from '@/types/common';
import { TemplateConfigurations } from '@/constants/templateConfig';

export const isTemplateSupportBG = (templateType: Templates) => {
  const template = TemplateConfigurations[templateType];
  return template?.showBackground ?? false;
};
